export const PADODOCURL = "https://docs.padolabs.org/";
export const PADODOCURLHOWTOWORK = "https://docs.padolabs.org/How-PADO-Works/";
export const PADODOCURLPRIVACY = "https://docs.padolabs.org/Privacy-Policy";
export const PADOEXTENSIONDOWNLOADURL =
  "https://chrome.google.com/webstore/detail/pado/oeiomhmbaapihbilkfkhmlajkeegnjhe";
